import { useEffect, useState } from 'react';

/**
 * Хук для отслеживания размеров окна браузера.
 *
 * Возвращает объект с текущими значениями ширины и высоты экрана.
 * Значения обновляются при изменении размеров окна (`resize`).
 *
 * @example
 * ```tsx
 * import React from 'react';
 * import { useScreenSize } from './useScreenSize';
 *
 * const Component = () => {
 *   const { width, height } = useScreenSize();
 *
 *   return (
 *     <div>
 *       <p>Ширина: {width}px</p>
 *       <p>Высота: {height}px</p>
 *     </div>
 *   );
 * };
 * ```
 *
 * @returns {{ width: number, height: number }}
 * Объект с шириной и высотой окна:
 * - `width` — текущая ширина окна в пикселях
 * - `height` — текущая высота окна в пикселях
 */

export const useScreenSize = () => {
    const [screenSize, setScreenSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            setScreenSize({
                width: window.innerWidth,
                height: window.innerHeight,
            });
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return screenSize;
};
